import React from "react";


export default function ActaConfirmDialog({
  open,
  eyebrow = "Confirmation",
  title,
  description,
  confirmLabel = "Confirmer",
  cancelLabel = "Annuler",
  saving = false,
  savingLabel = "Enregistrement…",
  danger = false,
  onConfirm,
  onClose,
}) {
  if (!open) {
    return null;
  }

  return (
    <div
      className="fixed inset-0 z-[160] flex items-center justify-center acta-modal-overlay p-3 sm:p-4"
      role="dialog"
      aria-modal="true"
      data-testid="acta-confirm-dialog"
      onClick={() => {
        if (!saving) {
          onClose?.();
        }
      }}
    >
      <div
        className="acta-modal-surface w-full rounded-3xl bg-[var(--do-bg-solid)] p-5 shadow-2xl sm:max-w-md sm:p-6"
        onClick={(event) =>
          event.stopPropagation()
        }
      >
        <div className="flex items-start justify-between gap-4">
          <div>
            <div className="label-eyebrow">
              {eyebrow}
            </div>

            <h2 className="mt-1 font-heading text-xl font-black text-[var(--do-ink)]">
              {title}
            </h2>

            {description ? (
              <p className="mt-2 text-sm leading-6 text-[var(--do-muted)]">
                {description}
              </p>
            ) : null}
          </div>

          <button
            type="button"
            disabled={saving}
            onClick={onClose}
            aria-label="Fermer"
            className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-[var(--do-border)] text-xl font-black text-[var(--do-muted)] disabled:opacity-50"
          >
            ×
          </button>
        </div>

        <div className="mt-6 grid gap-3 sm:grid-cols-2">
          <button
            type="button"
            disabled={saving}
            onClick={onClose}
            className="min-h-[50px] rounded-xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-5 text-sm font-black text-[var(--do-ink)] disabled:opacity-50"
          >
            {cancelLabel}
          </button>

          <button
            type="button"
            disabled={saving}
            onClick={onConfirm}
            data-testid="acta-confirm-dialog-confirm"
            className={
              danger
                ? "min-h-[50px] rounded-xl border border-[var(--do-danger-border)] bg-[var(--do-danger-soft)] px-5 text-sm font-black text-[var(--do-danger)] disabled:opacity-50"
                : "min-h-[50px] rounded-xl bg-[var(--do-accent)] px-5 text-sm font-black text-[var(--do-on-accent)] disabled:opacity-50"
            }
          >
            {saving
              ? savingLabel
              : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
